
import { Vue, Component } from 'vue-property-decorator';
import { MetaInfo } from 'vue-meta';

import AnimatedSection from '@/components/games/AnimatedSection.vue';
import GamesList from '@/components/games/GamesList.vue';
import GamesHeader from '@/components/games/GamesHeader.vue';
import IndentedContainer from '@/components/games/IndentedContainer.vue';
import HeaderNav from '@/components/landing/HeaderNav.vue';
import PageFooter from '@/components/common/PageFooter.vue';
import Page from '@/components/common/Page.vue';
import { Apps } from '@/constants/apps';
import { NoRobots } from '@/constants/meta';

@Component({
  metaInfo(): MetaInfo {
    return {
      title: 'Playrix games',
      meta: [NoRobots],
    };
  },
  computed: {
    Apps() {
      return Apps;
    },
  },
  components: {
    Page,
    PageFooter,
    HeaderNav,
    IndentedContainer,
    GamesHeader,
    AnimatedSection,
    GamesList,
  },
})
export default class Main extends Vue {}
